import React from 'react';
import ModalBox from '../../components/ModalBox';
import './index.scss';
import { Row } from 'react-materialize';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import Tooltip from '@material-ui/core/Tooltip';
import ImageViewer from 'react-simple-image-viewer';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { formats, formatsText, formatsInputFile } from '../../utils/imagesAccept';
import { allNotifications } from '../../utils/toastify';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ToastContainer } from 'react-toastify';
import services from '../../services/services';
import { toISODateString } from '../../utils/dateFormat';
import PdfIcon from '../../image/pdf.svg';
import { toCurrencyString } from '../../utils/currencyFormat';

const { notifyErrorBottomRight, notifySuccessBottomRight } = allNotifications;

const StyledBadge = withStyles(theme => ({
  badge: {
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 5px',
    background: '#dc6b2f',
    color: '#fff',
    top: 9,
    right: -10,
    fontSize: '0.65rem'
  }
}))(Badge);

class ProcedureDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalActive: true,
      modalDelete: false,
      selectedDate: props.location.state.selectedDate ? props.location.state.selectedDate : '',
      isEdit: props.location.state.selectedDate !== undefined,
      isDetails: props.location.state.isDetails,
      procedure: props.location.state.procedure,
      imagens: props.location.state.imagens ? props.location.state.imagens : [],
      listaProceduresFaturadas: props.location.state.listaProceduresFaturadas ? props.location.state.listaProceduresFaturadas : [],
      totalImagens: 0,
      btnDisabled: true,
      btnLoading: false,
      currentImage: 0,
      isViewerOpen: false,
      toastMessage: false,
      imagesViewer: [],
      imgCategories: [
        {
          key: 0,
          title: 'RX/Imagem Inicial',
          value: 'RXINICIAL',
          required: props.location.state.procedure.flag_rxinicial === true,
          imagesPending: [],
          description:
            'Utilize esse espaço para inclusão de radiografia (periapical ou interproximal ou panorâmica) com objetivo de diagnóstico e planejamento do tratamento.'
        },
        {
          key: 1,
          title: 'RX/Imagem Final',
          value: 'RXFINAL',
          required: props.location.state.procedure.flag_rxfinal === true,
          imagesPending: [],
          description:
            'Utilize esse espaço para inclusão de radiografia periapical final com objetivo de análise técnica da qualidade do tratamento clínico executado.'
        },
        {
          key: 2,
          title: 'Laudo/Termo',
          value: 'LAUDOTERMO',
          required: props.location.state.procedure.flag_necessita_laudo === true,
          imagesPending: [],
          description:
            'Utilize esse espaço para inclusão de laudos e termos referentes ao tratamento que está sendo realizado.'
        },
        {
          key: 3,
          title: 'Opcionais',
          value: 'OPCIONAL',
          scope: 'OPCIONAL',
          required: false,
          imagesPending: [],
          description:
            'Utilize esse espaço para inclusão de relatórios e justificativas.'
        },
        {
          key: 4,
          title: 'Fotografia Inicial',
          value: 'OPCIONAL',
          scope: 'FOTOINICIAL',
          required: props.location.state.procedure.flg_foto_inicial === true,
          imagesPending: [],
          description:
            'Utilize esse espaço para inclusão de fotografia inicial.'
        },
        {
          key: 5,
          title: 'Fotografia Final',
          value: 'OPCIONAL',
          scope: 'FOTOFINAL',
          required: props.location.state.procedure.flg_foto_final === true,
          imagesPending: [],
          description:
            'Utilize esse espaço para inclusão de fotografia final.'
        }
      ]
    };
  }

  componentDidMount = () => {
    this.validarProcedimento();
  };

  closeImageViewer = () => {
    this.setState({ currentImage: 0, isViewerOpen: false });
  };

  getImageFileNameFromUrl = url => {
    if (!url) return '';

    const sanitizedUrl = url.split('?')[0];
    const parts = sanitizedUrl.split('/');
    return decodeURIComponent(parts[parts.length - 1] || '');
  };

  getOptionalImageScope = image => {
    const fileName = this.getImageFileNameFromUrl(image.url);

    if (fileName.startsWith('FOTOINICIAL__')) return 'FOTOINICIAL';
    if (fileName.startsWith('FOTOFINAL__')) return 'FOTOFINAL';
    if (fileName.startsWith('OPCIONAL__')) return 'OPCIONAL';

    return 'OPCIONAL';
  };

  getImageScope = image => {
    if (!image) return '';
    if (image.categoria !== 'OPCIONAL') return image.categoria;
    return this.getOptionalImageScope(image);
  };

  isImageInCategory = (image, imgCategory) => {
    const categoryScope = imgCategory.scope || imgCategory.value;
    return this.getImageScope(image) === categoryScope;
  };

  getCategoryImages = imgCategory => {
    const { imagens } = this.state;
    return imagens.filter(img => this.isImageInCategory(img, imgCategory));
  };

  buildUploadFileName = (name, imgCategory) => {
    if (imgCategory.value !== 'OPCIONAL') return name;

    const categoryScope = imgCategory.scope || 'OPCIONAL';
    const prefixByScope = {
      FOTOINICIAL: 'FOTOINICIAL__',
      FOTOFINAL: 'FOTOFINAL__'
    };

    const prefix = prefixByScope[categoryScope];
    if (!prefix) return name;
    if (name.startsWith(prefix)) return name;
    return `${prefix}${name}`;
  };

  openImageViewer = async (index, imgCategory) => {
    const imagesViewer = this.getCategoryImages(imgCategory)
      .filter(imagem => !imagem.url.includes('.pdf'))
      .map(imagem => imagem.url);

    await this.setState({ imagesViewer });
    this.setState({ currentImage: index, isViewerOpen: true });
  };

  toggleCreate = () => {
    this.setState(prevState => ({
      modalActive: !prevState.modalActive
    }));

    localStorage.setItem('listaProceduresFaturadas', JSON.stringify(this.state.listaProceduresFaturadas));

    this.props.history.goBack();
  };

  notify = message => {
    this.setState({ toastMessage: true });
    notifyErrorBottomRight(message);
  };

  procedimentoLiberado = procedure => procedure.flag_pagamento_pre_faturamento ? 'S' : 'N'

  // TODO: Encapsular validação de imagens
  handleAddImage = async (event, imgCategory, cod_proced) => {
    // validates the image and add it to imagesPending state from wrapper
    await this.imageValidation(event, imgCategory, cod_proced); // devolve a imagesPending -> ver se eh um array ou uma imagem só
    await this.validarProcedimento();
  };

  maxImgQntReached = cod_proced => {
    let totalImagens = this.state.totalImagens;
    const maxQntImages = 10;
    const maxQntImagensDoc = 20;
    const docProceduresList = [
      "98958569",
      "98966162",
      "98968564"
    ];

    let maxImgNumber = docProceduresList.includes(cod_proced) ? maxQntImagensDoc : maxQntImages;

    if (totalImagens >= maxImgNumber)
      return true;

    return false;
  }

  readFile = file =>
    new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });

  /*compress = file =>
    new Promise(resolve => {
      Resizer.imageFileResizer(file, 720, 1280, 'JPEG', 60, 0, uri => resolve(uri), 'blob');
    });*/

  imageValidation = (event, imgCategory, cod_proced) => this.changeFileImage(event, imgCategory, cod_proced);

  changeFileImage = async (event, imgCategory, cod_proced) => {
    let files = event.target.files[0];
    //const maxImgSize = 150000;
    const securityMaxImgSize = 10000000;

    if (!files) return;

    if (
      !formats.some(f =>
        files.name
          .split('.')
          .pop()
          .toLowerCase()
          .includes(f.toLowerCase())
      )
    ) {
      this.notify(`As extensões válidas são ${formatsText}.`);
      return;
    }

    if (files.size > securityMaxImgSize) {
      this.notify(`3166 - Arquivo enviado excede o tamanho máximo permitido (O arquivo deve ter no máximo 10 MB).`);
      return;
    }

    if (this.maxImgQntReached(cod_proced)) {
      this.notify(`Quantidade máxima de anexos atingida`)
      return;
    }


    /*if (files.size > maxImgSize) {
      const { name, lastModifiedDate } = files;
      files = await this.compress(files);
      files.name = name;
      files.lastModifiedDate = lastModifiedDate;
    }*/

    const promises = await this.readFile(files).then(result => {
      const stateCopy = Object.assign({}, this.state.imgCategories);

      const objectURL = window.URL.createObjectURL(files); // link virtual da imagem

      const jaExiste =
        stateCopy[imgCategory.key].imagesPending.find(x => x.name === files.name) !== undefined;

      if (jaExiste) {
        const arrayName = files.name.split('.');
        const name = arrayName[0];
        const ext = arrayName[1];

        let counter = 0;

        while (
          stateCopy[imgCategory.key].imagesPending.find(x => x.name === files.name) !== undefined
        ) {
          files.name = `${name}_${counter}.${ext}`;
          counter += 1;
        }
      }

      stateCopy[imgCategory.key].imagesPending.push({
        name: files.name,
        src: objectURL,
        type: `.${files.type.split('/')[1]}`,
        file: files
      });
      this.setState(stateCopy);
    });

    await Promise.resolve(promises);
    this.setState({ totalImagens: this.state.totalImagens + 1 })
  };

  handleDateChange = event => {
    this.setState({ selectedDate: event.target.value }, () => {
      this.validarProcedimento();
    });
  };

  handleSalvar = async () => {
    await this.setState({ btnDisabled: true, btnLoading: true });

    let dataRealizacao = new Date(this.state.selectedDate);
    let dateYearAgo = new Date();
    let today = new Date();

    dataRealizacao.setHours(0, 0, 0, 0);
    dateYearAgo.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    dataRealizacao.setDate(dataRealizacao.getDate() + 1);
    dateYearAgo.setFullYear(today.getFullYear() - 1);

    if (dataRealizacao > today || dataRealizacao < dateYearAgo) {
      this.setState({ btnDisabled: false, btnLoading: false });
      this.notify('A data de realização informada é anterior aos últimos 12 meses ou data futura. Não é possível seguir com o faturamento.');
      return;
    }

    dataRealizacao = toISODateString(dataRealizacao);
    const { cod_creden, cod_interno, orcamento, cod_proced } = this.state.procedure;

    // try {
    //   await services.mobileengine('adicionarInfoProcedimento', {
    //     codigoPrestador: cod_creden,
    //     gtoId: orcamento,
    //     idProcedimento: cod_interno,
    //     dataRealizacao
    //   });
    // } catch (error) {
    //   this.setState({ btnDisabled: false, btnLoading: false });
    //   this.notify('Erro ao salvar informações do procedimento');
    //   return;
    // }

    const newProcedure = {
      ...this.state.procedure,
      selected_data_realizacao: dataRealizacao
    };

    this.setState(previousState => {
      const existingProcedure = previousState.listaProceduresFaturadas.find(item =>
        item.cod_interno === newProcedure.cod_interno
      );

      if (existingProcedure) {
        return {
          listaProceduresFaturadas: [
            ...previousState.listaProceduresFaturadas.map(item =>
              item.cod_interno === newProcedure.cod_interno ? newProcedure : item
            )
          ]
        };
      } else {
        return {
          listaProceduresFaturadas: [
            ...previousState.listaProceduresFaturadas,
            newProcedure
          ]
        };
      }
    });

    const { imgCategories } = this.state;

    const listaCategorias = imgCategories.filter(img => img.imagesPending.length > 0);
    let promisesAdd;

    if (listaCategorias.length > 0) {
      listaCategorias.forEach(categoria => {
        promisesAdd = categoria.imagesPending.map(async img => {
          const { file } = img;
          const nomeArquivo = this.buildUploadFileName(img.name, categoria);
          const responseUrl = await services.mobileengine('adicionarImagemProcedimento', {
            codigoPrestador: cod_creden,
            gtoId: orcamento,
            idProcedimento: cod_interno,
            categoriaImagem: categoria.value,
            nomeArquivo
          });

          const responseImg = await services.gcp('uploadImagemGcp', { url: responseUrl, file });
          return responseImg;
        });
      });

      try {
        const resultPromises = await Promise.all(promisesAdd);

        if (resultPromises.some(x => x === undefined)) {
          this.setState({ btnDisabled: false, btnLoading: false });
          this.notify('Erro ao salvar imagens');
          return;
        }
      } catch (error) {
        this.setState({ btnDisabled: false, btnLoading: false });
        this.notify('Erro ao salvar imagens');
        return;
      }
      this.notifySuccess(`O procedimento ${cod_proced.trim()} está pronto para faturar`);
      this.toggleCreate();
    } else {
      this.notifySuccess(`O procedimento ${cod_proced.trim()} está pronto para faturar`);
      this.toggleCreate();
    }
  };

  notifySuccess = async message => {
    await this.setState({ toastMessage: false });
    notifySuccessBottomRight(message);
  };

  validarProcedimento = () => {
    const { imgCategories, selectedDate } = this.state;
    const imagemObrigatoria = imgCategories.some(cat => cat.required);

    let possuiErro = false;
    if (imagemObrigatoria) {
      imgCategories
        .filter(cat => cat.required)
        .forEach(cat => {
          if (cat.imagesPending.length === 0 && this.getCategoryImages(cat).length === 0) {
            possuiErro = true;
          }
        });
    }
    if (selectedDate === '' || possuiErro) {
      this.setState({ btnDisabled: true });
    } else {
      this.setState({ btnDisabled: false });
    }
  };

  handleClose = () => {
    this.setState({ modalDelete: false });
  };

  handleOk = async () => {
    const { cod_creden, cod_interno, orcamento } = this.state.procedure;

    await services
      .mobileengine('excluirDataRealizacao', {
        codigoPrestador: cod_creden,
        gtoId: orcamento,
        idProcedimento: cod_interno
      })
      .catch(err => {
        this.notify(err);
      });
    await this.setState({ modalDelete: false });
    await this.setState(previousState => ({
      listaProceduresFaturadas: [
        ...previousState.listaProceduresFaturadas.filter(item => item.cod_interno !== cod_interno)
      ]
    }));
    this.notifySuccess('Procedimento alterado com sucesso!');
    this.toggleCreate();
  };

  render() {
    const {
      modalActive,
      imgCategories,
      selectedDate,
      procedure,
      btnDisabled,
      btnLoading,
      modalDelete,
      isEdit,
      isDetails,
      isViewerOpen,
      currentImage,
      imagesViewer,
      toastMessage
    } = this.state;
    const yearAgo = new Date().getTime() - 1000 * 60 * 60 * 24 * 365;

    return (
      <>
        <ModalBox
          modalActive={modalActive}
          modalLabel={`GTO ${procedure.orcamento}`}
          onChange={this.toggleCreate}
        >
          {toastMessage && <ToastContainer />}
          {isDetails ? (
            <ExpansionPanel id="gtodetails-panel">
              <ExpansionPanelSummary
                aria-controls="panel1a-content"
                className="panel-header"
                style={{ cursor: 'default' }}
              >
                <div
                  className="row"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 0
                  }}
                >
                  <div className="col s11" style={{ padding: 0, margin: 0 }}>
                    <p className="card-label">
                      <span className="txt-procedure">
                        {`${procedure.cod_proced.trim()} - ${procedure.procedimento}`}
                      </span>
                    </p>
                    <div className="info-procedure" style={{ fontSize: 12, color: '#696969' }}>
                      {procedure.regiao !== '' && Number.isNaN(procedure.regiao) && (
                        <span>{`Região: ${procedure.regiao} | `}</span>
                      )}
                      {procedure.regiao !== '' && !Number.isNaN(procedure.regiao) && (
                        <span>{`Dente: ${procedure.regiao} | `}</span>
                      )}
                      {procedure.face !== '' && <span>{`Face: ${procedure.face}`}</span>}
                    </div>
                    <p style={{ fontSize: 12, color: '#696969' }}>
                      {`Data da realização: ${procedure.data_cancelamento.substring(0, 10) !== '01/01/0001' ? '-' : procedure.fim_tratamento}`}
                    </p>
                    <p style={{ fontSize: 12, color: '#696969' }}>
                      {`Qtd.: 1 | Qtd. US: ${procedure.valor_uso > 0 ? `${toCurrencyString(procedure.valor_uso?.toFixed(2))}` : '-'}`}
                    </p>
                    <p style={{ fontSize: 12, color: '#696969' }}>
                      {`Valor: ${procedure.valor > 0 ? `R$ ${toCurrencyString(procedure.valor?.toFixed(2))}` : '-'} | Franquia: ${procedure.franquia > 0 ? `R$ ${toCurrencyString(procedure.franquia?.toFixed(2))}` : '-'}`}
                    </p>
                    <p style={{ fontSize: 12, color: '#696969' }}>
                      {`Aut.: ${this.procedimentoLiberado(procedure)} | Valor Glosa: ${new Date(`${procedure.data_pagamento.split('/')[2]}-${procedure.data_pagamento.split('/')[1]}-${procedure.data_pagamento.split('/')[0]} 00:00`) > new Date()
                        ? '-'
                        : procedure.valor_glosa > 0 ? `R$ ${toCurrencyString(procedure.valor_glosa?.toFixed(2))}` : '-'}`}
                    </p>
                    <p style={{ fontSize: 12, color: '#696969' }}>
                      {`Cód. de glosa.: ${procedure.data_cancelamento.substring(0, 10) !== '01/01/0001' ? '-' : (
                        new Date(`${procedure.data_pagamento.split('/')[2]}-${procedure.data_pagamento.split('/')[1]}-${procedure.data_pagamento.split('/')[0]} 00:00`) > new Date()
                          ? '-'
                          : procedure.flag_pagamento ? '-' : `${procedure.cod_glosa_tiss} - ${procedure.descr_glosa}`
                      )
                        }`}
                    </p>
                  </div>
                </div>
              </ExpansionPanelSummary>
            </ExpansionPanel>
          ) : (
            <ExpansionPanel id="gtodetails-panel" style={{ marginBottom: 18 }}>
              <ExpansionPanelSummary
                aria-controls="panel1a-content"
                className="panel-header panel-proc-details"
                style={{ padding: '0px 16px 14px 13px', color: '#1B365D', fontWeight: 500 }}
              >
                {procedure.flag_pagamento_pre_faturamento === true ? (
                  <span className="status-badge autorizado">Autorizado</span>
                ) : (
                  <span className="status-badge nao-autorizado">Não autorizado</span>
                )}

                <p className="card-label" style={{ marginTop: 6 }}>
                  <span className="txt-procedure">{procedure.procedimento}</span>
                </p>
                <div style={{ color: '#696969' }}>
                  {procedure.regiao !== '' && !Number.isNaN(procedure.regiao) && (
                    <p className="card-label">
                      <span>{`Dente: ${procedure.regiao}`}</span>
                    </p>
                  )}
                  {procedure.face !== '' && (
                    <p className="card-label">
                      <span>{`Face: ${procedure.face}`}</span>
                    </p>
                  )}
                  {procedure.regiao !== '' && Number.isNaN(procedure.regiao) && (
                    <p className="card-label">
                      <span>{`Região: ${procedure.regiao}`}</span>
                    </p>
                  )}
                  {procedure.descr_glosa_pre_faturamento !== '' && procedure.flag_pagamento_pre_faturamento !== true && (
                    <p className="card-label">
                      <span>{`Código TISS: ${procedure.cod_glosa_tiss_pre_faturamento} ${procedure.descr_glosa_pre_faturamento}`}</span>
                    </p>
                  )}
                  {procedure.descr_glosa_amigavel_pre_faturamento !== '' && (
                    <p className="card-label" style={{ fontWeight: 600, color: '#212121' }}>
                      {procedure.descr_glosa_amigavel_pre_faturamento}
                    </p>
                  )}
                </div>
              </ExpansionPanelSummary>
            </ExpansionPanel>
          )}
          <form noValidate>
            {!isDetails && (
              <Row>
                <TextField
                  style={{ padding: 0 }}
                  className={`col ${isEdit && !isDetails ? 's11' : 's12'}`}
                  id="date"
                  label="Data da realização do procedimento"
                  type="date"
                  disabled={isDetails}
                  value={selectedDate}
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    max: toISODateString(new Date()),
                    min: toISODateString(new Date(yearAgo))
                  }}
                  onChange={e => this.handleDateChange(e)}
                />
                {isEdit && (
                  <div className="col s1 right-align" style={{ marginTop: 14, padding: 0 }}>
                    <Tooltip title="Excluir">
                      <IconButton
                        aria-label="delete"
                        style={{ color: '#cb4f0d' }}
                        onClick={() => this.setState({ modalDelete: true })}
                      >
                        <CancelRoundedIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </Row>
            )}
            {procedure.data_cancelamento.substring(0, 10) !== '01/01/0001' ? "" : (
              <Row>
                <p style={{ fontSize: 16, color: '#1B365D', fontWeight: 600 }}>
                  <span>Anexos</span>
                </p>
                {!isDetails && (["98958569", "98966162", "98968564"].includes(procedure.cod_proced.trim()) ? (
                  <p style={{ fontSize: 12, color: '#696969', fontWeight: 400, marginBottom: 20 }}>
                    <span>Use o botão 'Anexar Arquivo' para realizar o upload de até 20 arquivos de 10 MB cada com formato PNG, JPG, JPEG ou PDF</span>
                  </p>
                ) : (
                  <p style={{ fontSize: 12, color: '#696969', fontWeight: 400, marginBottom: 20 }}>
                    <span>Use o botão 'Anexar Arquivo' para realizar o upload de até 10 arquivos de 10 MB cada com formato PNG, JPG, JPEG ou PDF</span>
                  </p>))}
                {imgCategories.map(imgCategory => (
                  <ExpansionPanel key={imgCategory.key}>
                    <ExpansionPanelSummary
                      style={{
                        height: 51,
                        padding: '0px 16px 14px 13px',
                        color: '#1B365D',
                        fontWeight: 500
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                    >
                      <p style={{ fontSize: 16 }}>
                        <StyledBadge
                          badgeContent={
                            this.getCategoryImages(imgCategory).length + imgCategory.imagesPending.length
                          }
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                          }}
                        >
                          {imgCategory.title}
                          {imgCategory.required && !isDetails && (
                            <span style={{ color: '#696969', fontSize: 14, fontWeight: 400 }}>
                              {` (obrigatório)`}
                            </span>
                          )}
                        </StyledBadge>
                      </p>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className="acordeon-content">
                      {!isDetails && <p style={{ color: '#212121' }}>{imgCategory.description}</p>}
                      <div className="attach-images__container">
                        {!isDetails && (
                          <li className="image">
                            <div className="box-image">
                              <span>
                                <div className="attach">
                                  <span className="upImage" />
                                  <div className="btn-upLoad">
                                    <input
                                      className="upload-input"
                                      onChange={event => this.handleAddImage(event, imgCategory, this.state.procedure.cod_proced.trim())}
                                      type="file"
                                      accept={formatsInputFile}
                                    />
                                  </div>
                                </div>
                                <span className="nameImage">Anexar Arquivo</span>
                              </span>
                            </div>
                          </li>
                        )}
                        {this.getCategoryImages(imgCategory).length > 0 &&
                          this.getCategoryImages(imgCategory)
                            .filter(img => !img.url.includes('.pdf'))
                            .map((imagem, index) => (
                              <>
                                <li className="image">
                                  <div className="box-image">
                                    <span>
                                      <div className="attach" style={{ marginBottom: 20 }}>
                                        <div className="box--thumbnail">
                                          <img
                                            crossorigin="anonymous"
                                            className="thumbnail"
                                            src={imagem.url}
                                            alt="thumbnail"
                                            onClick={() =>
                                              this.openImageViewer(index, imgCategory)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </span>
                                  </div>
                                </li>
                                {isViewerOpen && (
                                  <ImageViewer
                                    crossorigin="anonymous"
                                    src={imagesViewer}
                                    currentIndex={currentImage}
                                    onClose={this.closeImageViewer}
                                  />
                                )}
                              </>
                            ))}
                        {this.getCategoryImages(imgCategory).length > 0 &&
                          this.getCategoryImages(imgCategory)
                            .filter(img => img.url.includes('.pdf'))
                            .map((imagem, index) => (
                              <>
                                <li className="image">
                                  <div className="box-image">
                                    <span>
                                      <div className="attach" style={{ marginBottom: 20 }}>
                                        <div className="box--thumbnail-pdf">
                                          <a href={imagem.url} target="_blank">
                                            <img
                                              crossorigin="anonymous"
                                              className="thumbnail"
                                              src={PdfIcon}
                                              alt="thumbnail"
                                            />
                                          </a>
                                        </div>
                                      </div>
                                    </span>
                                  </div>
                                </li>
                              </>
                            ))}
                        {imgCategory.imagesPending.map((item, index) => (
                          <li className="image">
                            <div className="box-image">
                              <span>
                                <div className="attach">
                                  <div className={"box--thumbnail" + (item.name.includes('.pdf') ? '-pdf' : '')}>
                                    <span
                                      className="btn-close"
                                      role="button"
                                      tabIndex={0}
                                      onClick={() => {
                                        imgCategory.imagesPending.splice(index, 1);
                                        this.setState({ totalImagens: this.state.totalImagens - 1 });
                                        this.setState({ imgCategories });
                                        this.validarProcedimento();
                                      }}
                                    />
                                    {item.name.includes('.pdf') && (
                                      <img crossorigin="anonymous" className="thumbnail" src={PdfIcon} alt="thumbnail" />
                                    )}
                                    {!item.name.includes('.pdf') && (
                                      <img crossorigin="anonymous" className="thumbnail" src={item.src} alt="thumbnail" />
                                    )}
                                  </div>
                                </div>
                                <span className="nameImage">{item.name}</span>
                              </span>
                            </div>
                          </li>
                        ))}
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                ))}
              </Row>
            )}
            {!isDetails && (
              <div className="btn-enviar">
                <Button
                  variant="contained"
                  disableElevation
                  onClick={this.handleSalvar}
                  disabled={btnDisabled}
                >
                  {btnLoading ? (
                    <CircularProgress
                      disableShrink
                      style={{ width: 20, height: 20, color: '#fff' }}
                    />
                  ) : (
                    'Salvar'
                  )}
                </Button>
              </div>
            )}
          </form>

          <Dialog
            maxWidth="xs"
            open={modalDelete}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center', color: '#1b365d' }}>
              <strong>Apagar data de realização?</strong>
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText id="alert-dialog-description">
                Ao apagar a data de realização do procedimento,
                {' '}
                <strong>todos os anexos serão excluídos</strong>
                . As informações deverão ser
                preenchidas novamente para o faturamento do procedimento.
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
              <Button onClick={this.handleClose} color="inherit">
                Cancelar
              </Button>
              <Button onClick={this.handleOk} color="inherit">
                <strong>OK</strong>
              </Button>
            </DialogActions>
          </Dialog>
        </ModalBox>
      </>
    );
  }
}

export default ProcedureDetails;